import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define the initial state
interface SelectionState {
  qlikAppSelections: Record<string, any>;
  selectionIndustry?: string;
  selectionIndustryClassName?: string;
  selectionCompAnnualRev?: string;
  // isSelectionApplying: boolean;
  // isPageSelectionApplied: boolean;
  // onlyOnePossibleBranchValue: string | null;
}

const initialState: SelectionState = {
  qlikAppSelections: {},
  selectionIndustry: "",
  selectionIndustryClassName: "",
  selectionCompAnnualRev: "",
  // isSelectionApplying: false,
  // isPageSelectionApplied: false,
  // onlyOnePossibleBranchValue: null,
};

// Create the slice
const qlikSelectionSlice = createSlice({
  name: "qlikSelection",
  initialState,
  reducers: {
    // Set Qlik app selections
    setQlikAppSelections(
      state,
      action: PayloadAction<{ appRef: string; selections: any }>
    ) {
      const { appRef, selections } = action.payload;
      state.qlikAppSelections = {
        ...state.qlikAppSelections,
        [appRef]: selections,
      };
      // state.isSelectionApplying = false; // Reset loading state
    },
    setSelectionIndustry(state, action: PayloadAction<string>) {
      state.selectionIndustry = action.payload;
    },
    setSelectionIndustryClassName(state, action: PayloadAction<string>) {
      state.selectionIndustryClassName = action.payload;
    },
    setSelectionCompAnnualRev(state, action: PayloadAction<string>) {
      state.selectionCompAnnualRev = action.payload;
    },
    // setPageSelections(
    //   state,
    //   action: PayloadAction<{ isPageSelectionApplied: boolean }>
    // ) {
    //   state.isPageSelectionApplied = action.payload.isPageSelectionApplied;
    // },

    // Set the loading state for selections
    // setSelectionLoadingState(
    //   state,
    //   action: PayloadAction<{ isLoading: boolean; totalSelectionCount?: number }>
    // ) {
    //   const { isLoading, totalSelectionCount } = action.payload;

    //   if (totalSelectionCount !== undefined) {
    //     const appSelections = state.qlikAppSelections["small"] || [];
    //     const appSelectionCount = appSelections.reduce(
    //       (total: number, item: any) => total + (item.selectionCount || 0),
    //       0
    //     );
    //     state.isSelectionApplying = appSelectionCount !== totalSelectionCount;
    //   } else {
    //     state.isSelectionApplying = isLoading;
    //   }
    // },

    // Set the value for only one possible branch
    // setOnlyOnePossibleBranchValue(
    //   state,
    //   action: PayloadAction<string | null>
    // ) {
    //   state.onlyOnePossibleBranchValue = action.payload;
    // },
  },
});

// Export actions
export const {
  setQlikAppSelections,
  setSelectionIndustry,
  setSelectionIndustryClassName,
  setSelectionCompAnnualRev,
  // setPageSelections,
  // setSelectionLoadingState,
  // setOnlyOnePossibleBranchValue,
} = qlikSelectionSlice.actions;

// Export selectors
export const selectQlikAppSelections = (state: RootState, appRef: string) =>
  state.qlikSelection.qlikAppSelections[appRef];
// export const selectIsSelectionApplying = (state: RootState) =>
//   state.qlikSelection.isSelectionApplying;
// export const selectIsPageSelectionApplying = (state: RootState) =>
//   state.qlikSelection.isPageSelectionApplied;
// export const selectOnlyOnePossibleBranchValue = (state: RootState) =>
//   state.qlikSelection.onlyOnePossibleBranchValue;
export const selectAppSelectionCount = (state: RootState, appRef: string) =>
  state.qlikSelection.qlikAppSelections[appRef]?.reduce(
    (total: number, item: any) => total + item.selectionCount,
    0
  ) ?? 0;

// Export the reducer
export default qlikSelectionSlice.reducer;

export type { SelectionState };